"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var types_1 = require("../configuration/types");
function useAriaLiveMessage() {
    var context = React.useContext(types_1.OuiAriaLiveContext);
    function useAssertiveAriaMessage(message) {
        context.setAssertiveMessage(message);
    }
    function usePoliteAriaMessage(message) {
        context.setPoliteMessage(message);
    }
    return { useAssertiveAriaMessage: useAssertiveAriaMessage, usePoliteAriaMessage: usePoliteAriaMessage };
}
exports.default = useAriaLiveMessage;
//# sourceMappingURL=useAriaLiveMessage.js.map